import { useNavigate } from 'react-router-dom';

const useBack = () => {
  const navigate = useNavigate();
  return { goBack: () => navigate(-1) };
};

export default useBack;
